import React from 'react';
import PageHeader from 'components/template/global-components/page-header';
import Faq from 'components/template/section-components/faq-v1';
import MainLayout from 'components/layouts/MainLayout';

const FaqV1 = () => {
    return <div>
        <MainLayout>
        <PageHeader headertitle="Preguntas Frecuentes" subheader="FAQ" customclass="mb-5" />
        <Faq />
        </ MainLayout>
    </div>
}

export default FaqV1

